
export let API_URL = "https://app-back.amcemig.com";

export const ACTION_PREFIX = "@API_";
export const ACTION_LOGIN = "LOGIN_APP";
export const ACTION_ERROR = 'ACTION_ARROR';

//This actions say how to save the obtained data to the store
export const STATE_ACTION_APPEND = "APPEND";//Append to an array of items
export const STATE_ACTION_SET = "SET";//Set the data in the response as the object in the state
export const STATE_ACTION_SET_SINGLE = "SET_SINGLE";//Set the data in the response inside the state object with id as key
export const STATE_ACTION_SEARCH_N_DELETE = "SEARCH_N_DELETE";//Search the object in an array in the store and remove it
export const STATE_ACTION_SEARCH_N_REPLACE = "SEARCH_N_REPLACE";//Search the object in an array in the store and replace it with the one in the response
export const STATE_ACTION_CLEAR = "CLEAR";//Set corresponding state piece to undefined

export const LOGIN_STATE = {
    NOT_LOGGED: "NOT_LOGGED",
    LOGGED_IN: "LOGGED_IN",
    BAD_CREDENTIALS: "BAD_CREDENTIALS",
    LOGIN_BLOCKED: "LOGIN_BLOCKED",
    LOGIN_ERROR: "LOGIN_ERROR",
};

export const initialState = {
    loggedIn: LOGIN_STATE.NOT_LOGGED
};

export const commonHeaders = {
    credentials: 'include',
    Accept: "application/json"
};


if (process.env.REACT_APP_BUILD === 'dev') {
    //console.log("YOU ARE IN DEVELOPMENT MODE");

    //    window.localStorage.timeTravel = '2018-04-30';
    API_URL = window.localStorage.host || "https://amcemig-back.tide.company";
    //console.log("Time travel is active");//Go to Api.js -> L: 6, 30, 31, 98, 102, 155, 156, 348, 349
}


// WEBPACK FOOTER //
// ./src/App/services/Api/constants.js